/**
 *
 * media-config reducer
 *
 */

import { SET_USER_LOCATION } from './config-constants';

const initialState = {
    videocore: {
        advertising: {
            dfp: {
            },
        },
    },
};

const configReducer = (state = initialState, action) => {

    switch (action.type) {

        case SET_USER_LOCATION:
            return {
                ...state,
                videocore: {
                    ...state.videocore,
                    advertising: {
                        ...state.videocore.advertising,
                        dfp: {
                            ...state.videocore.advertising.dfp,
                            isEu: action.data.isEuropeanUnion,
                        },
                    },
                },
            };
        default:
            return state;

    }

};

export default configReducer;
